export const RESET_ERRORS = 'RESET_ERRORS';
export const PROCESS_REQUEST_ERROR = 'PROCESS_REQUEST_ERROR';

export interface ResponseErrors {
    [key: string]: string;
  }
